import React from "react";
import "../styles/Hero.css";
import { CardBody, CardContainer, CardItem } from "../aceternity/ui/3d-card";
import { Link } from "react-router-dom";
import { TypewriterEffectSmooth } from "../aceternity/ui/type-writer";

const textSize="lg:text-[2rem] 2xl:text-[3rem]";
const words1 = [
  {
    text: "Welcome ",
    className: `cinzel ${textSize}`,
  },
  {
    text: " to ",
    className: `cinzel ${textSize}`,
  },
];
const words2 = [
  {
    text: "Karishma's",
    className: `text-black-500 dark:text-white-500 ${textSize}`,
  },
  {
    text: " Closet",
    className: `text-black-500 dark:text-white-500 ${textSize}`,
  },
];

function Hero() {
  return (
    <div className="hero-container lg:p-[2rem] grid grid-cols-1 lg:grid-cols-3 poppins bg-gradient-to-b from-custom-pink via-light-custom-pink to-white p-2">
      
      <div className="hero-content flex flex-col items-center justify-center p-5 ">
        <TypewriterEffectSmooth words={words1} />
        <TypewriterEffectSmooth words={words2} />
        <p className="text-[#183940] font-serif text-2xl p-5 mt-5 text-center">
          Discover Latest Trends
        </p>
        <Link to="/shop">
        <button className="prata bg-white p-2 rounded-sm shadow-md w-[15rem] text-xl">
          Shop Now
        </button>
        </Link>
      </div>
      
      
        {/* <div className="lg:w-[40rem] w-full flex items-center m-5 lg:m-0 justify-center"> */}
          <CardContainer className="m-5 2xl:h-[50rem] 2xl:w-[40rem] lg:h-[45rem] lg:w-[30rem] w-[20rem] h-[30rem]">
            <CardBody className="relative rounded-xl bg-white shadow-2xl p-6 border border-gray-200 w-full h-full">
              <CardItem translateZ="100" className="w-full h-full">
                <img
                  src="./assets/hero2.jpeg"
                  className="object-cover rounded-lg w-full h-full"
                  alt="thumbnail"
                />
              </CardItem>
            </CardBody>
          </CardContainer>
        {/* </div> */}
      {/* <div className="card-section flex lg:mt-[5rem] m-5 lg:flex-row flex-wrap justify-center lg:justify-left items-center "> */}
        
          <div
            className=" flex justify-center "
          >
            <CardContainer className="inter-var 2xl:w-[35rem] lg:w-[15rem] md:w-[20rem] w-[15rem] m-5  lg:mt-10 ">
              <CardBody className="relative rounded-xl bg-white shadow-2xl p-6 border border-gray-200 h-[fit-content] pb-[2rem]">
                <CardItem translateZ="100" className="w-full  mt-4">
                  <img
                    src="./assets/hero1.jpeg"
                    className="h-[20rem] 2xl:h-[30rem] w-full object-cover rounded-xl group-hover/card:shadow-xl"
                    alt="thumbnail"
                  />
                </CardItem>
                <CardItem
                  translateZ="50"
                  className="text-xl text-neutral-600 dark:text-black mt-2"
                >
                  Stylish Designs
                </CardItem>
                <CardItem
                  as="p"
                  translateZ="60"
                  className="text-neutral-500 text-sm max-w-sm mt-2 dark:text-gray-400"
                >
                  Elevate your wardrobe with our Curated Collection of Premium
                  fashion
                </CardItem>
                <div className="flex justify-between items-center">
                  <CardItem
                    translateZ={20}
                    as={Link}
                    to="/shop"
                    target="__blank"
                    className="p-4 rounded-xl text-xs font-normal dark:text-black shadow-md border-2 border-black dark:border-white"
                  >
                    Explore more
                  </CardItem>
                  <CardItem
                    translateZ={20}
                    as={Link}
                    to="/shop?category=menswear"
                    target="__blank"
                    className="p-4 rounded-xl bg-black dark:bg-white dark:text-black text-white text-xs font-bold shadow-md border-black dark:border-white"
                  >
                    View more
                  </CardItem>
                </div>
              </CardBody>
            </CardContainer>
        
        
        {/* </div> */}
      </div>
    </div>
  );
}

export default Hero;
